import { useState } from "react";
import { NavLink } from "react-router-dom";
import image1 from "../img/utpl.png";

const NAV_ITEMS = [
  { label: "Líneas temáticas", href: "#tematica" },
  { label: "Sede", href: "#sede" },
  { label: "Agenda", href: "#agenda" },
  { label: "Loja", href: "#loja" },
  { label: "Hospedaje", href: "#hotel" },
];

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-[#004270] backdrop-blur-md  shadow-sm transition-all">
      <div className="max-w-6xl mx-auto px-6 sm:px-0  ">
        <div className="flex items-center justify-between h-20">
          
          {/* LOGO */}
          <NavLink to="/" className="flex items-center shrink-0">
            <img 
              src={image1} 
              alt="UTPL" 
              className="h-8 w-auto object-contain transition-transform duration-300 hover:scale-105" 
            />
          </NavLink>

          {/* BOTÓN HAMBURGUESA (Móvil) */}
          <button
            onClick={() => setOpen(!open)}
            type="button"
            className="md:hidden p-2.5 rounded-xl text-[#004270] hover:bg-slate-100 focus:outline-none transition-colors"
            aria-label="Abrir menú"
            aria-expanded={open}
          >
            <div className="w-6 h-5 relative flex flex-col justify-between items-center">
              <span className={`w-full h-0.5 bg-[#004270] rounded-full transition-all duration-300 ${open ? "rotate-45 translate-y-2" : ""}`} />
              <span className={`w-full h-0.5 bg-[#004270] rounded-full transition-all duration-300 ${open ? "opacity-0" : ""}`} />
              <span className={`w-full h-0.5 bg-[#004270] rounded-full transition-all duration-300 ${open ? "-rotate-45 -translate-y-2" : ""}`} />
            </div>
          </button>

          {/* ÚNICO MENÚ (Responsive mediante Tailwind) */}
          <nav
            className={`
              absolute md:relative top-full md:top-auto left-0 md:left-auto w-full md:w-auto
              bg-white md:bg-transparent border-b md:border-none border-slate-100 shadow-lg md:shadow-none
              flex flex-col md:flex-row items-stretch md:items-center p-4 md:p-0 space-y-2 md:space-y-0 md:space-x-1 lg:space-x-3
              transition-all duration-300 ease-in-out z-50
              ${open ? "opacity-100 visible translate-y-0" : "opacity-0 md:opacity-100 invisible md:visible -translate-y-2 md:translate-y-0"}
            `}
          >
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-3.5 py-2 text-base md:text-sm font-medium text-white hover:text-[#febe10] hover:bg-slate-50 md:hover:bg-transparent transition-colors rounded-lg"
              >
                {item.label}
              </a>
            ))}

            {/* BOTÓN DE ACCIÓN */}
            <a
              href="#inscripcion"
              onClick={() => setOpen(false)}
              className="mt-2 md:mt-0 md:ml-3 px-5 py-2.5 text-center text-sm font-bold text-[#004270] bg-[#febe10] hover:bg-[#e5ab0d] rounded-xl shadow-sm transition-all active:scale-95"
            >
              Inscripción
            </a>
          </nav>

        </div>
      </div>
    </header>
  );
}

export default Header;